import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { GetMenusBO } from '../menus-new.modal';
@Injectable({
    providedIn: 'root'
})
export class FunctionDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public executeFunction(state: GetMenusBO): void {
    this.getFunctionList(state).subscribe(x => super.next(x));
  }
  getFunctionList(state?: GetMenusBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/MenuFunctionality/getMeunuFunctionality?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['fList'],
            count: response['totalCount']
          }
      ))


  }
}

